import { ServiceFetch } from '../service-fetch'

export default class RedeemGiftReceivederListModel extends ServiceFetch {
    getRedeemGiftReceivederListBy = (data) => this.authFetch({
        url: 'redeem-gift-receiveder-list/getRedeemGiftReceivederListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
